const MAX_FILENAME_LENGTH = 30; // Maximum length for the filename excluding the extension

export const truncateFilename = (filename, length = MAX_FILENAME_LENGTH) => {
  const lastDotIndex = filename.lastIndexOf('.');

  if (lastDotIndex === -1) return filename; // No extension found

  const baseName = filename.slice(0, lastDotIndex);
  const extension = filename.slice(lastDotIndex);

  if (baseName.length <= length) {
      return filename; // No need to truncate
  }

  const startLength = Math.ceil(length / 2);
  const endLength = length - startLength - 3;  // Leave space for '...'
  let truncatedBaseName = baseName.slice(0, startLength) + '...' + baseName.slice(baseName.length - endLength)
  truncatedBaseName = truncatedBaseName.replaceAll('-', '‑'); // Replace hyphen as they trigger word-breaks

  return truncatedBaseName + extension;
};
